import React, { useState } from "react";
import Api from "../common/api";
import {
  BrowserRouter as Router,
  Link,
  withRouter,
  useHistory,
  useLocation,
} from "react-router-dom";
import menusvgg from "../img/menusvgg.svg";
import enicon from "./../img/en-icon.svg";
import tricon from "./../img/tr-icon.svg";
import searchiconsvg from "./../img/searchicon.svg";
import searchiconmobile from "./../img/searchiconmobile.svg";
import mobilesankologo from "../img/sankologomobile.png";
import closelogomobile from "../img/closelogomobile.png";
import mobileok from "../img/mobileok.png";
import sankologosvg from "../img/sanko-enerji-logo.svg";
import mobileelectricbuy from "../img/mobileelectricbuy.png";
import sankologomobilesvg from "../img/sanko-enerji-logo-mobile.svg";
import "./../styles/Navbar.scss";

const Navbar = () => {
  let location = useLocation();
  const lang = localStorage.getItem("lang");

  React.useEffect(() => {
    Api.get("/home/getmenu").then((res) => {
      setNavItem(res.data.items);
    });
  }, [location.pathname]);


    const changeLang = () => {
      var newURL = "";

      if (location.pathname == "/") newURL = "/en";
      else if (location.pathname == "/kurumsal/hakkimizda") newURL = "/en/corporate/about-us";
      else if (location.pathname == "/kurumsal/tarihce") newURL = "/en/corporate/history";
      else if (location.pathname == "/kurumsal/vizyon") newURL = "/en/corporate/vision";
      else if (location.pathname == "/kurumsal/yonetim-kurulu") newURL = "/en/corporate/board-of-directors";
      else if (location.pathname == "/kurumsal/yonetim-ekibi") newURL = "/en/corporate/management-team";
      else if (location.pathname == "/kurumsal/strateji-ve-is-gelistirme-ekibi") newURL = "/en/corporate/strategy-and-business-development-team";
      else if (location.pathname == "/kurumsal/faaliyet-raporlarimiz") newURL = "/en/corporate/annual-reports";
      else if (location.pathname == "/kurumsal/bilgi-toplumu-hizmetleri") newURL = "/en/corporate/Company-Information-Portal";
      else if (location.pathname == "/kurumsal/kisisel-verilerin-korunmasi") newURL = "/en/corporate/protection-personal-data";
      else if (location.pathname == "/faaliyet-alanlari/elektrik-uretimi") newURL = "/en/activities/electricity-production";
      else if (location.pathname == "/faaliyet-alanlari/elektrik-ticareti") newURL = "/en/activities/electricity-trading";
      else if (location.pathname == "/faaliyet-alanlari/elektrik-satisi") newURL = "/en/activities/electricity-sales";
      else if (location.pathname == "/faaliyet-alanlari/yesil-enerji") newURL = "/en/activities/green-energy";
      else if (location.pathname == "/surdurulebilirlik/politikalarimiz") newURL = "/en/sustainability/Our-Policies";
      else if (location.pathname == "/surdurulebilirlik/sosyal-sorumluluk-projelerimiz") newURL = "/en/sustainability/Our-Social-Responsibility-Projects";
      else if (location.pathname == "/surdurulebilirlik/surdurulebilirlik-raporlari") newURL = "/en/sustainability/sustainability-reports";
      else if (location.pathname == "/medya-merkezi/haberlerimiz") newURL = "/en/media-center/our-news";
      else if (location.pathname == "/medya-merkezi/logolarimiz") newURL = "/en/media-center/Our-Logos";
      else if (location.pathname == "/medya-merkezi/fotograf-galerisi") newURL = "/en/media-center/photo-gallery";
      else if (location.pathname == "/medya-merkezi/kurumsal-videolar") newURL = "/en/media-center/corporate-videos";
      else if (location.pathname == "/yayinlar/diger-yayinlarimiz") newURL = "/en/publications/Other-Publications";
      else if (location.pathname == "/kariyer/ik-politikamiz") newURL = "/en/career/Our-Human-Resources-Policy";
      else if (location.pathname == "/kariyer/kariyer-firsatlarimiz") newURL = "/en/career/Career-Opportunities";
      else if (location.pathname == "/iletisim") newURL = "/en/contact";
      else if (location.pathname == "/online-islemler") newURL = "/en/online-services";
      else if (location.pathname == "/faaliyet-alanlari/yesil-enerji?q=1032") newURL = "/en/activities/green-energy?q=1032";
      else if (location.pathname == "/faaliyet-alanlari/elektrik-satisi?q=1026") newURL = "/en/activities/electricity-sales?q=1026";
      else if (location.pathname == "/en") newURL = "/";
      else if (location.pathname == "/en/corporate/about-us") newURL = "/kurumsal/hakkimizda";
      else if (location.pathname == "/en/corporate/history") newURL = "/kurumsal/tarihce";
      else if (location.pathname == "/en/corporate/vision") newURL = "/kurumsal/vizyon";
      else if (location.pathname == "/en/corporate/board-of-directors") newURL = "/kurumsal/yonetim-kurulu";
      else if (location.pathname == "/en/corporate/management-team") newURL = "/kurumsal/yonetim-ekibi";
      else if (location.pathname == "/en/corporate/strategy-and-business-development-team") newURL = "/kurumsal/strateji-ve-is-gelistirme-ekibi";
      else if (location.pathname == "/en/corporate/annual-reports") newURL = "/kurumsal/faaliyet-raporlarimiz";
      else if (location.pathname == "/en/corporate/Company-Information-Portal") newURL = "/kurumsal/bilgi-toplumu-hizmetleri";
      else if (location.pathname == "/en/corporate/protection-personal-data") newURL = "/kurumsal/kisisel-verilerin-korunmasi";
      else if (location.pathname == "/en/activities/electricity-production") newURL = "/faaliyet-alanlari/elektrik-uretimi";
      else if (location.pathname == "/en/activities/electricity-trading") newURL = "/faaliyet-alanlari/elektrik-ticareti";
      else if (location.pathname == "/en/activities/electricity-sales") newURL = "/faaliyet-alanlari/elektrik-satisi";
      else if (location.pathname == "/en/activities/green-energy") newURL = "/faaliyet-alanlari/yesil-enerji";
      else if (location.pathname == "/en/sustainability/Our-Policies") newURL = "/surdurulebilirlik/politikalarimiz";
      else if (location.pathname == "/en/sustainability/Our-Social-Responsibility-Projects") newURL = "/surdurulebilirlik/sosyal-sorumluluk-projelerimiz";
      else if (location.pathname == "/en/sustainability/sustainability-reports") newURL = "/surdurulebilirlik/surdurulebilirlik-raporlari";
      else if (location.pathname == "/en/media-center/our-news") newURL = "/medya-merkezi/haberlerimiz";
      else if (location.pathname == "/en/media-center/Our-Logos") newURL = "/medya-merkezi/logolarimiz";
      else if (location.pathname == "/en/media-center/photo-gallery") newURL = "/medya-merkezi/fotograf-galerisi";
      else if (location.pathname == "/en/media-center/corporate-videos") newURL = "/medya-merkezi/kurumsal-videolar";
      else if (location.pathname == "/en/publications/Other-Publications") newURL = "/yayinlar/diger-yayinlarimiz";
      else if (location.pathname == "/en/career/Our-Human-Resources-Policy") newURL = "/kariyer/ik-politikamiz";
      else if (location.pathname == "/en/career/Career-Opportunities") newURL = "/kariyer/kariyer-firsatlarimiz";
      else if (location.pathname == "/en/contact") newURL = "/iletisim";
      else if (location.pathname == "/en/online-services") newURL = "/online-islemler";
      else if (location.pathname == "/en/activities/green-energy?q=1032") newURL = "/faaliyet-alanlari/yesil-enerji?q=1032";
      else if (location.pathname == "/en/activities/electricity-sales?q=1026") newURL = "/faaliyet-alanlari/elektrik-satisi?q=1026";
      else {
        if (lang == "en") newURL = "/";
        else newURL = "/en"
      }

      if (lang == "en") {
        localStorage.setItem("lang", "tr");
        //window.location.href = "/";
        window.location.href = newURL;
      } else {
        localStorage.setItem("lang", "en");
        //window.location.href = "/en";
        window.location.href = newURL;
      }
    };


    const [isSubActive, setIsSubActive] = useState([]);

  const [navItem, setNavItem] = useState();

  let onlinetext = "Online İşlemler";
  
  const [onlineIslemler, setOnlineIslemler] = useState({
    id: 8,
    Name: onlinetext,
    Name_EN:"Online Services",
    Link: "https://musteriportal.sankoenerji.com.tr/Login/IndexDefault",
  });

  const [isActive, setIsActive] = useState(false);
  const [isActiveMobile, setIsActiveMobile] = useState(false);
  const [isActiveInput, setIsActiveInput] = useState(false);
  const [isWide, setIsWide] = useState(false);
  const history = useHistory();

  const [searching, setSearch] = useState([]);

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      history.push("/arama/" + searching.target.value);
    }
  };

  const  handleMobilesearch = () => {
    history.push("/arama/" + searching.target.value);
    setIsActiveMobile(false)
  }
  const onClickHandler = () => {
    setIsActive(!isActive);
    setIsActiveMobile(true);
  };

  return (
    <header className={isWide ? "homepage-nav only-homepage" : "homepage-nav"}>
      <div className="navbar-left">
        <button onClick={() => onClickHandler()} className="target-btn">
          <img className="hamburger-menu" src={menusvgg} alt="hamburger-icon" />
        </button>
        <div className={isActive ? "popup-menu-active" : "popup-menu-deactive"}>
        {lang == "en"
              ? (
          <ul>
            {navItem
              ? navItem.map((item) => {
                  return (
                    item.Name_EN ? (
                    <li
                      className={item.submenu ? "subdrop" : null}
                      key={item.id}
                    >
                      <Link
                        className="nav-menu-link"
                        to={
                          item.Link == "iletisim"
                            ? "/en/" + item.Link_EN
                            : "/en/" + item.Link_EN + "/" + item.submenu[0].Link_EN
                        }
                      >
                        {item.Name_EN}
                      </Link>
                      <ul className="sub-drop-down">
                        {item.submenu
                          ? item.submenu.map((sub) => {
                              return (
                                sub.Name_EN ? (
                                <li key={sub.id}>
                                  {item.Link_EN ==
                                  location.pathname.split("/")[2] ? (
                                    <a
                                      className="nav-menu-link"
                                      href={"/en/" + item.Link_EN + "/" + sub.Link_EN}
                                    >
                                      {sub.Name_EN} 
                                    </a>
                                  ) : (
                                    <Link
                                      onClick={() => setIsActive(false)}
                                      className="nav-menu-link"
                                      to={"/en/" + item.Link_EN + "/" + sub.Link_EN}
                                    >
                                      {sub.Name_EN}
                                    </Link>
                                  )}
                                </li>
                                ):""
                              );
                            })
                          : null}
                      </ul>
                    </li>
                    ):""
                  );
                })
              : null}
          </ul>
          ): (
            <ul>
              {navItem
                ? navItem.map((item) => {
                    return (
                      item.Name ? (
                      <li
                        className={item.submenu ? "subdrop" : null}
                        key={item.id}
                      >
                        <Link
                          className="nav-menu-link"
                          to={
                            item.Link == "iletisim"
                              ? "/" + item.Link
                              : "/" + item.Link + "/" + item.submenu[0].Link
                          }
                        >
                          {item.Name}
                        </Link>
                        <ul className="sub-drop-down">
                          {item.submenu
                            ? item.submenu.map((sub) => {
                                return (
                                  sub.Name ? (
                                  <li key={sub.id}>
                                    {item.Link ==
                                    location.pathname.split("/")[1] ? (
                                      <a
                                        className="nav-menu-link"
                                        href={"/" + item.Link + "/" + sub.Link}
                                      >
                                        {sub.Name}
                                      </a>
                                    ) : (
                                      <Link
                                        onClick={() => setIsActive(false)}
                                        className="nav-menu-link"
                                        to={"/" + item.Link + "/" + sub.Link}
                                      >
                                        {sub.Name}
                                      </Link>
                                    )}
                                  </li>
                                  ):""
                                );
                              })
                            : null}
                        </ul>
                      </li>
                      ):""
                    );
                  })
                : null}
            </ul>
            )}
          <ul className="online-islemler">
            <li>
              <Link
                className="nav-menu-link online-islem"
                to={
                  lang == "en"
                    ? "/en/online-services"
                    : "/online-islemler"
                }
              >
                {lang == "en" ? "Online Services" : "Online İşlemler"}
              </Link>
            </li>            
          </ul>
        </div>
        <Link to="/">
          <img className="navbar-sanco-logo" src={sankologosvg} alt="logo" />
        </Link>
      </div>
      <div
        className={isActiveMobile ? "mobile-version active" : "mobile-version"}
      >
        <div className="mobile-top">
          <div className="logo-section">
            <div className="mobile-logo">
              <img
                className="mobile-sanko-logo"
                style={{ width: "315px" }}
                src={sankologomobilesvg}
                alt="asdas"
              />
              <div className="mobile-btns">
                {lang =="en" ?(
                <a onClick={() => changeLang()} href="#">TR</a>
                ):(
                  <a onClick={() => changeLang()} href="#">EN</a>
                )}
                <img
                  onClick={() => setIsActiveMobile(false)}
                  src={closelogomobile}
                  alt="sd"
                />
              </div>
            </div>
          </div>
        </div>
        <div className="mobile-input-section">
          <div className="mobile-input">
                  {lang == "en" ? (
                <input onChange={setSearch}
              onKeyPress={handleKeyPress} placeholder="Enter keyword" />
          ):(<input onChange={setSearch}
            onKeyPress={handleKeyPress} placeholder="Aramak istediğiniz kelimeyi yazınız" />)}
            <img src={searchiconmobile} alt="asdasd" onClick={() => handleMobilesearch()} />
          </div>
        </div>
        <hr />
        <div className="mobile-tabs">
        {lang == "en"
              ? ( <ul>
            {navItem
              ? navItem.map((tab) => {
                  return (
                    tab.Name_EN ? (
                    <li
                      className="mobile-nav-items"
                      key={tab.id}
                    >
                      {tab.Name == "İletişim" ? ( 
                         <Link 
                         to={"/en/" + tab.Link_EN}
                         onClick={() => setIsActiveMobile(false)} >
                        {tab.Name_EN}
                        <img
                          className={isSubActive == tab.id ? "rotate" : null}
                          src={mobileok}
                          alt="sd"
                        />
                      </Link>) : (  
                      
                      <Link  onClick={
                        isSubActive == tab.id  ? 
                        () => setIsSubActive(false)
                        :
                         () => setIsSubActive(tab.id)
                      }>
                        {tab.Name_EN}
                        <img
                          className={isSubActive == tab.id ? "rotate" : null}
                          src={mobileok}
                          alt="sd"
                        />
                      </Link>
                      )}
                    
                      <div className="mobile-sub-drop">
                      <ul className={isSubActive == tab.id ? "dropdown-sub active": "dropdown-sub"}>
                        {tab.submenu
                          ? tab.submenu.map((sub) => {
                              return (
                                sub.Name_EN ? (
                              <li key={sub.id}>
                                  <Link
                                      onClick={() => setIsActiveMobile(false)} 
                                      to={"/en/" + tab.Link_EN + "/" + sub.Link_EN}>
                                    {sub.Name_EN}
                                    </Link>
                                </li>
                                ):""
                                );
                            })
                          : null}
                            </ul>
                          </div>
                    </li>
                    ):""
                  );
                })
              : null}
              <li className="mobile-nav-items last" key="8">
                <Link
                  className="nav-menu-link online-islem"
                  onClick={() => setIsActiveMobile(false)} 
                  to={
                    lang == "en"
                      ? "/en/online-services"
                      : "/online-islemler"
                  }
                >
                  {lang == "en" ? "Online Services" : "Online İşlemler"}
                </Link>
              </li>
          </ul>
              ):
              ( <ul>
                {navItem
                  ? navItem.map((tab) => {
                      return (
                        <li
                          className="mobile-nav-items"
                          key={tab.id}
                        >
                          {tab.Name == "İletişim" ? ( 
                             <Link 
                             to={"/" + tab.Link}
                             onClick={() => setIsActiveMobile(false)} >
                            {tab.Name}
                            <img
                              className={isSubActive == tab.id ? "rotate" : null}
                              src={mobileok}
                              alt="sd"
                            />
                          </Link>) : (  <Link  onClick={
                            isSubActive == tab.id  ? 
                            () => setIsSubActive(false)
                            :
                             () => setIsSubActive(tab.id)
                          }>
                            {tab.Name}
                            <img
                              className={isSubActive == tab.id ? "rotate" : null}
                              src={mobileok}
                              alt="sd"
                            />
                          </Link>)}
                        
                          <div className="mobile-sub-drop">
                          <ul className={isSubActive == tab.id ? "dropdown-sub active": "dropdown-sub"}>
                            {tab.submenu
                              ? tab.submenu.map((sub) => {
                                  return (
                                  <li key={sub.id}>
                                      <Link
                                          onClick={() => setIsActiveMobile(false)} 
                                          to={"/" + tab.Link + "/" + sub.Link}>
                                        {sub.Name}
                                        </Link>
                                    </li>
                                    );
                                })
                              : null}
                                </ul>
                              </div>
                        </li>
                      );
                    })
                  : null}
                <li className="mobile-nav-items last" key="8">
                  <Link
                    className="nav-menu-link online-islem"
                    onClick={() => setIsActiveMobile(false)} 
                    to={
                      lang == "en"
                        ? "/en/online-services"
                        : "/online-islemler"
                    }
                  >
                    {lang == "en" ? "Online Services" : "Online İşlemler"}
                  </Link>
                </li>
              </ul>
                  )}
        </div>
        <hr />
        <div className="mobile-link-section">
          <div className="icons">
            <a href="https://twitter.com/Sanko_Enerji" target="blank">
              <i className="fab fa-twitter homepage-social-media-icon"></i>
            </a>
            <a
              href="https://www.linkedin.com/company/sanko-enerji/"
              target="blank"
            >
              <i className="fab fa-linkedin homepage-social-media-icon"></i>
            </a>
            <a href="https://www.facebook.com/sankoenergy/" target="blank">
              <i className="fab fa-facebook-square homepage-social-media-icon"></i>
            </a>
            <a href="https://www.instagram.com/sankoenerji/" target="blank">
              <i className="fab fa-instagram homepage-social-media-icon"></i>
            </a>
          </div>
          <div className="mobile-electric-logo">
            <img src={mobileelectricbuy} alt="sd" />
          </div>
        </div>
      </div>
      <div className="navbar-right">
      
        <input
          onChange={setSearch}
          onKeyPress={handleKeyPress}
          className={isActiveInput ? "navbar-input" : "navbar-none"}
          type="text"
          placeholder={lang == "en" ? "Enter keyword":"Aradığınız kelimeyi yazınız.."}
        />
        <img
          onClick={() => setIsActiveInput(!isActiveInput)}
          className="search-btn"
          src={searchiconsvg}
          alt="search-icon mbl"
        />
        <a onClick={() => changeLang()} href="#">
          <img src={lang == "en" ? tricon : enicon} alt="enicon" />
        </a>
      </div>
    </header>
  );
};

export default Navbar;
